export enum RecruiterBadgeType {
  FREELANCER_RECRUITER = 'freelancer-recruiter.svg',
}
